import type { ReactNode } from "react";

/**
 * Rótulo em cima, campo embaixo, ajuda embaixo do campo quando houver.
 *
 * Com `erro`, a borda fica vermelha e o motivo toma o lugar da ajuda: quem
 * errou vê onde, e não só um aviso geral no canto da tela.
 *
 * Vive sozinho porque a porta de entrada e a ficha da conta usam os dois, e
 * elas deixaram de morar no mesmo arquivo: a porta abre na tela inicial e a
 * ficha só existe para quem já entrou.
 */
export function Campo({
  rotulo,
  ajuda,
  erro,
  className,
  children,
}: {
  rotulo: string;
  ajuda?: string;
  erro?: string;
  className?: string;
  children: ReactNode;
}): ReactNode {
  return (
    <label className={className} data-erro={erro ? "" : undefined} style={{ display: "grid", gap: 4 }}>
      <span className="label-muted">{rotulo}</span>
      {children}
      {erro ? (
        <span role="alert" style={{ fontSize: 11, color: "var(--danger)" }}>
          {erro}
        </span>
      ) : ajuda && (
        <span className="muted" style={{ fontSize: 11 }}>
          {ajuda}
        </span>
      )}
    </label>
  );
}
